import {createGlobalStyle} from "styled-components";
import {pixel2vw} from "../../utils/utils";

const GlobalStyle = createGlobalStyle`
  body {
    a {
      color: var(--ant-primary-color);
    }
    .s-scrollable{
      /* 设置中心有个全局img display: block的样式 */
      img{
        display: unset;
      }
      .primary-btn{
        color: var(--ant-primary-color-hover) !important
      }
    }
    /* 设置中心ant-btn蓝色 */
    .ant-btn.ant-btn-default:not([disabled]):hover,
    .ant-btn.ant-btn-default:not([disabled]):focus{
      border-color: var(--ant-primary-color-hover) !important;
      color: var(--ant-primary-color-hover) !important;
    }
    margin: 0;
    .ant-btn-primary{
      border-color: var(--ant-primary-color) !important;
      background: var(--ant-primary-color) !important;
    }
    .ant-btn-primary:focus, .ant-btn-primary:hover{
      border-color: var(--ant-primary-color-hover) !important;
        background: var(--ant-primary-color-hover) !important;
    }
    .ant-btn-primary[disabled], .ant-btn-primary[disabled]:active, .ant-btn-primary[disabled]:focus, .ant-btn-primary[disabled]:hover{
      color: rgba(0,0,0,.25);
      border-color: #d9d9d9 !important;
      background: #f5f5f5 !important;
      text-shadow: none;
      box-shadow: none;
    }
    .ant-popover-arrow{    
      border-top-color: #fff !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      border-left-color: transparent !important;
    }
    .ant-btn-link{
      span{
      color: var(--ant-primary-color) !important;
      }
    }
    .ant-btn-link:not([disabled]):hover, .ant-btn-link:not([disabled]):focus {
      color: var(--ant-primary-color-hover) !important;
      background: transparent;
    }
  #traffic-container {
    >div:first-child{
      height:100%
    }
    height: inherit;
    overflow-x: hidden;
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    ::-webkit-scrollbar-thumb {
      background: #E8EBF6;

      &:hover{
        background: #9A9EBA;
      }
    }
  }
  .ant-modal-title {
    font-weight: 600;
  }
  .ant-select-item-option-active:not(.ant-select-item-option-disabled){
    background: #FFF2EA;
  }
  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    color:#FC8352 !important;
    font-weight: 600;
    background-color: white;
  }
  .table-odd {
    background: #FAFAFA;
  }
  .ant-table-tbody > tr:hover > td{
    background-color: #FFF2EA !important;
  }
  .ant-table-thead > tr > th {
    font-weight: 700;
    background-color: #EFEFEF !important;
    white-space: nowrap;
  }
  .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > th, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > td, .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > td {
    border-right: 1px solid #E2E2E2;
  }
  .ant-table-body {
    overflow-y: auto!important;
    ::-webkit-scrollbar {
      width: 4px;
      height: 8px;
    }
    ::-webkit-scrollbar-thumb {
      background: #E8EBF6;

      &:hover{
        background: #9A9EBA;
      }
    }
    ::-webkit-scrollbar-track{
      background: #eeeeee;
      border-radius: 2px;
    }
  }
  .ant-table-thead > tr > th {
    border-bottom: 1px solid #E2E2E2;
    white-space: nowrap;
  }
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #E2E2E2;
  }
  .ant-table tbody > tr.table-odd > td {
    background: #FAFAFA;
  }
  .ant-table tbody > tr.table-even > td {
    background: #FFFFFF;
  }
  .ant-btn-primary:hover, .ant-btn-primary:focus {
    color: #fff;
    background: #FC8352;
    border-color: #FC8352;
  }
  .ant-select::after {
    position: absolute;
    top: 15px;
    right: 10px;
    display: block;
    content: '';
    border-width: 5px;
    border-style:solid;
    border-color: #D8D8D8 transparent transparent transparent;
  }
  .ant-select-arrow {
    display: none;
  }
  table tr th.ant-table-selection-column, table tr td.ant-table-selection-column {
    padding-right: 16px;
    padding-left: 16px;
  }
  .ant-modal-header {
    width: 720px;
    height: 48px;
    background: #F7F7F7;
    border-radius: 2px;
  }
  .ant-modal-footer{
    width: 720px;
    height: 64px;
    background: #F7F7F7;
    border-radius: 0px 0px 2px 2px;
  }
  .ant-btn {
    text-shadow: none;
    box-shadow: none;
  }
  .ant-modal-footer .ant-btn {
    width: 65px;
    height: 32px;
    text-shadow: none;
    box-shadow: none;
  }
  .ant-modal-footer button + button {
    margin-top: 6px;
    margin-right: 8px;
    margin-left: 16px
  }
  .ant-form-item-label > label::after {
    content: '';
    margin-right: 14px;
  }
  .modalForm .ant-form-item .ant-form-item-control .ant-form-item-control-input{
    width: 360px;
  }
  .modalForm .ant-form-item.imageListStyle .ant-form-item-control .ant-form-item-control-input{
    width:100%
  }
  .ant-row {
    margin-left: 30px;
    margin-bottom: 16px;
  }
  .ant-form-item .ant-input-textarea-show-count::after {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
  }
  .ant-drawer-content {
    border-top-left-radius: ${pixel2vw(24)};
    border-top-right-radius: ${pixel2vw(24)};
  }
  .ant-drawer-content-wrapper {
    max-height: ${pixel2vw(1004)};
  }
  .am-picker-popup-header-right {
    color: #FC8352 !important;
  }
  .am-picker-popup-header-left {
    color: #999999;
  }
  .ant-message-error {
    display: flex;
    align-items: center;
    svg {
      width: 16px;
      height: 16px;
    }
  }
  .ant-modal-mask {
    background-color: #130928;
    opacity: 0.32;
  }
  .ant-tree-draggable-icon {
    display: none;
  }
  .btn-primary {
    color: #fff;
    background-color: #FC8352;
    border-color: #FC8352;
  }
  .btn-primary:hover {
    color: #fff;
    background-color: #FC8352;
    border-color: #FC8352;
  }
  .am-modal-content{
    padding-top: ${pixel2vw(40)} !important;
    border-radius: ${pixel2vw(24)} !important;
  }
  .am-modal-header{
    padding: 0 ${pixel2vw(16)} ${pixel2vw(15)};
  }
  .am-modal-body{
    padding-bottom: ${pixel2vw(40)} !important;
  }
  .am-modal-title{
    font-weight: bold;
    color: #333333;
    font-size: ${pixel2vw(36)};
  }
  .scrm-img-error{
    opacity: 0;
  }
  :root{
    --message-bgc-left: #E9E9E9;
    --message-bgc-right: #D9EEFF;
    --message-font-left: #595959;
    --message-font-right: #595959;
  }
  }
`;

export default GlobalStyle
